// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTablePagination_wrapper__JFKOm","pageInput":"DataTablePagination_pageInput__8sDWA"};